export const messages = {
  title: {
    id: 'admin/promotions.form.review.discount',
  },
  nominalPrice: {
    id: 'admin/promotions.form.review.regular.nominal-price',
  },
  nominalShipping: {
    id: 'admin/promotions.form.review.regular.nominal-shipping',
  },
  maxShipping: {
    id: 'admin/promotions.form.review.regular.max-shipping',
  },
  percentualPrice: {
    id: 'admin/promotions.form.review.regular.percentual-price',
  },
  maxPrice: {
    id: 'admin/promotions.form.review.regular.max-price',
  },
  nominalLoyalty: {
    id: 'admin/promotions.form.review.regular.nominal-loyalty',
  },
  percentualShipping: {
    id: 'admin/promotions.form.review.regular.percentual-shipping',
  },
  freeShipping: {
    id: 'admin/promotions.form.review.regular.free-shipping',
  },
  gift: {
    id: 'admin/promotions.form.review.regular.gift',
  },
  percentualLoyalty: {
    id: 'admin/promotions.form.review.regular.percentual-loyalty',
  },
  formula: {
    id: 'admin/promotions.form.review.regular.formula',
  },
  priceTable: {
    id: 'admin/promotions.form.review.regular.price-table',
  },
}
